import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { CustomerFacade } from '@ridango/components';

import { Observable } from 'rxjs';

@Component({
    templateUrl: './account-change-email-page.component.html',
    styleUrls: ['./account-change-email-page.component.scss']
})
export class AccountChangeEmailPageComponent implements OnInit {
    isEmailChangeSent$: Observable<boolean> = this.customerFacade.isEmailChangeSent$;

    email: string;

    constructor(private translate: TranslateService, private router: Router, private customerFacade: CustomerFacade) {}

    ngOnInit() {
        this.customerFacade.resetCustomerNewEmail();
    }

    back() {
        this.router.navigate([this.translate.currentLang, 'account', 'profile']);
    }

    submitEmail(email: string) {
        this.email = email;
    }
}
